interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Cardano = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_26533)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#20439C"
      />
      <path
        d="M24.1814 61.7809C25.4698 61.0368 27.1163 61.4778 27.8604 62.7661C28.6045 64.0544 28.1635 65.701 26.8752 66.445C25.5869 67.1891 23.9403 66.7482 23.1963 65.4598C22.4522 64.1715 22.8931 62.5249 24.1814 61.7809Z"
        fill="white"
      />
      <path
        d="M73.0623 33.555C74.3506 32.8109 75.9972 33.2518 76.7413 34.5402C77.4853 35.8285 77.0444 37.4751 75.7561 38.2191C74.4677 38.9632 72.8212 38.5223 72.0771 37.2339C71.3331 35.9456 71.774 34.299 73.0623 33.555Z"
        fill="white"
      />
      <path
        d="M15.9692 67.6231C16.8028 67.1408 17.8638 67.4302 18.346 68.2569C18.8283 69.0837 18.5389 70.1515 17.7122 70.6338C16.8855 71.116 15.8176 70.8267 15.3353 70C14.8531 69.1663 15.1424 68.1054 15.9692 67.6231Z"
        fill="white"
      />
      <path
        d="M82.2315 29.3661C83.0652 28.8838 84.1261 29.1732 84.6084 29.9999C85.0907 30.8335 84.8013 31.8945 83.9746 32.3768C83.1478 32.859 82.08 32.5697 81.5977 31.7429C81.1154 30.9093 81.4048 29.8484 82.2315 29.3661Z"
        fill="white"
      />
      <path
        d="M36.2932 51.6879C38.8699 50.1998 42.1561 51.0816 43.6442 53.6583C45.1324 56.228 44.2505 59.5212 41.6739 61.0093C39.1041 62.4974 35.811 61.6156 34.3228 59.0389C32.8347 56.4623 33.7166 53.176 36.2932 51.6879Z"
        fill="white"
      />
      <path
        d="M58.2633 38.9976C60.8399 37.5095 64.1262 38.3914 65.6143 40.968C67.1024 43.5447 66.2206 46.8309 63.6439 48.319C61.0673 49.8072 57.781 48.9253 56.2929 46.3487C54.8048 43.7789 55.6866 40.4858 58.2633 38.9976Z"
        fill="white"
      />
      <path
        d="M26.8752 33.555C28.1635 34.299 28.6045 35.9456 27.8604 37.2339C27.1163 38.5223 25.4698 38.9632 24.1814 38.2191C22.8931 37.4751 22.4522 35.8285 23.1963 34.5402C23.9403 33.2518 25.5869 32.8109 26.8752 33.555Z"
        fill="white"
      />
      <path
        d="M75.7561 61.7809C77.0444 62.5249 77.4853 64.1715 76.7413 65.4598C75.9972 66.7482 74.3506 67.1891 73.0623 66.445C71.774 65.701 71.3331 64.0544 72.0771 62.7661C72.8212 61.4778 74.4677 61.0368 75.7561 61.7809Z"
        fill="white"
      />
      <path
        d="M17.7052 29.3661C18.5388 29.8484 18.8213 30.9094 18.3391 31.743C17.8568 32.5766 16.7958 32.8591 15.9622 32.3768C15.1286 31.8946 14.8461 30.8336 15.3284 30C15.8106 29.1663 16.8716 28.8839 17.7052 29.3661Z"
        fill="white"
      />
      <path
        d="M83.9748 67.6231C84.8084 68.1054 85.0909 69.1664 84.6086 70C84.1263 70.8336 83.0654 71.1161 82.2317 70.6338C81.3981 70.1516 81.1156 69.0906 81.5979 68.257C82.0802 67.4233 83.1411 67.1409 83.9748 67.6231Z"
        fill="white"
      />
      <path
        d="M41.6739 38.9975C44.2505 40.4856 45.1255 43.7719 43.6442 46.3485C42.1561 48.9252 38.8699 49.8001 36.2932 48.3189C33.7235 46.8308 32.8416 43.5445 34.3228 40.9679C35.811 38.3912 39.0972 37.5163 41.6739 38.9975Z"
        fill="white"
      />
      <path
        d="M63.6441 51.6811C66.2139 53.1692 67.0957 56.4555 65.6145 59.0321C64.1333 61.6088 60.8401 62.4837 58.2635 61.0025C55.6868 59.5144 54.8119 56.2281 56.2931 53.6515C57.7812 51.0748 61.0675 50.1999 63.6441 51.6811Z"
        fill="white"
      />
      <path
        d="M52.6623 21.7808C52.6623 23.269 51.4566 24.4746 49.9685 24.4746C48.4804 24.4746 47.2747 23.269 47.2747 21.7808C47.2747 20.2927 48.4804 19.0871 49.9685 19.0871C51.4566 19.0871 52.6623 20.2927 52.6623 21.7808Z"
        fill="white"
      />
      <path
        d="M52.6623 78.2192C52.6623 79.7073 51.4566 80.9129 49.9685 80.9129C48.4804 80.9129 47.2747 79.7073 47.2747 78.2192C47.2747 76.731 48.4804 75.5254 49.9685 75.5254C51.4566 75.5254 52.6623 76.731 52.6623 78.2192Z"
        fill="white"
      />
      <path
        d="M49.9683 13.486C50.9309 13.486 51.7113 12.7057 51.7113 11.743C51.7113 10.7804 50.9309 10 49.9683 10C49.0056 10 48.2253 10.7804 48.2253 11.743C48.2253 12.7057 49.0056 13.486 49.9683 13.486Z"
        fill="white"
      />
      <path
        d="M49.9683 90C50.9309 90 51.7113 89.2197 51.7113 88.257C51.7113 87.2944 50.9309 86.514 49.9683 86.514C49.0056 86.514 48.2253 87.2944 48.2253 88.257C48.2253 89.2197 49.0056 90 49.9683 90Z"
        fill="white"
      />
      <path
        d="M49.9685 42.6903C52.9402 42.6903 55.3492 40.2813 55.3492 37.3097C55.3492 34.338 52.9402 31.929 49.9685 31.929C46.9969 31.929 44.5879 34.338 44.5879 37.3097C44.5879 40.2813 46.9969 42.6903 49.9685 42.6903Z"
        fill="white"
      />
      <path
        d="M49.9685 68.064C52.9402 68.064 55.3492 65.655 55.3492 62.6834C55.3492 59.7117 52.9402 57.3027 49.9685 57.3027C46.9969 57.3027 44.5879 59.7117 44.5879 62.6834C44.5879 65.655 46.9969 68.064 49.9685 68.064Z"
        fill="white"
      />
      <path
        d="M59.2621 66.0938C57.7465 66.9687 57.2297 68.9046 58.1047 70.4134C58.9797 71.9291 60.9156 72.4458 62.4244 71.5709C63.94 70.6959 64.4568 68.76 63.5818 67.2512C62.7068 65.7424 60.7709 65.2188 59.2621 66.0938Z"
        fill="white"
      />
      <path
        d="M37.5128 28.4292C35.9971 29.3042 35.4804 31.2401 36.3554 32.7489C37.2303 34.2646 39.1662 34.7813 40.675 33.9063C42.1907 33.0314 42.7074 31.0955 41.8324 29.5867C40.9575 28.071 39.0216 27.5543 37.5128 28.4292Z"
        fill="white"
      />
      <path
        d="M66.2277 78.1639C65.1667 78.7771 64.8016 80.1343 65.4148 81.2022C66.0279 82.2632 67.3851 82.6283 68.453 82.0151C69.514 81.402 69.8791 80.0448 69.2659 78.9769C68.6528 77.9159 67.2956 77.5508 66.2277 78.1639Z"
        fill="white"
      />
      <path
        d="M31.4842 17.9849C30.4233 18.5981 30.0581 19.9553 30.6713 21.0231C31.2844 22.0841 32.6416 22.4493 33.7095 21.8361C34.7705 21.2229 35.1356 19.8657 34.5225 18.7979C33.9093 17.7369 32.5521 17.3717 31.4842 17.9849Z"
        fill="white"
      />
      <path
        d="M40.675 66.0936C39.1593 65.2187 37.2303 65.7354 36.3554 67.2511C35.4804 68.7667 35.9971 70.6958 37.5128 71.5707C39.0284 72.4457 40.9575 71.929 41.8324 70.4133C42.7074 68.8976 42.1907 66.9686 40.675 66.0936Z"
        fill="white"
      />
      <path
        d="M62.4244 28.4292C60.9087 27.5543 58.9797 28.071 58.1047 29.5867C57.2297 31.1023 57.7465 33.0314 59.2621 33.9063C60.7778 34.7813 62.7068 34.2646 63.5818 32.7489C64.4568 31.2332 63.94 29.3042 62.4244 28.4292Z"
        fill="white"
      />
      <path
        d="M33.7095 78.1639C32.6485 77.5508 31.2844 77.9159 30.6713 78.9769C30.0581 80.0379 30.4233 81.402 31.4842 82.0151C32.5452 82.6283 33.9093 82.2632 34.5225 81.2022C35.1356 80.1412 34.7705 78.7771 33.7095 78.1639Z"
        fill="white"
      />
      <path
        d="M68.453 17.9849C67.392 17.3717 66.0279 17.7369 65.4148 18.7979C64.8016 19.8588 65.1667 21.2229 66.2277 21.8361C67.2887 22.4493 68.6528 22.0841 69.2659 21.0231C69.8791 19.9622 69.514 18.5981 68.453 17.9849Z"
        fill="white"
      />
      <path
        d="M31.3811 50C31.3811 48.2501 29.9619 46.8377 28.2189 46.8377C26.4759 46.8377 25.0566 48.257 25.0566 50C25.0566 51.743 26.4759 53.1622 28.2189 53.1622C29.9619 53.1622 31.3811 51.743 31.3811 50Z"
        fill="white"
      />
      <path
        d="M74.8811 50C74.8811 48.2501 73.4619 46.8377 71.7189 46.8377C69.9759 46.8377 68.5566 48.257 68.5566 50C68.5566 51.743 69.9759 53.1622 71.7189 53.1622C73.4619 53.1622 74.8811 51.743 74.8811 50Z"
        fill="white"
      />
      <path
        d="M17.4506 50C17.4506 48.7737 16.4585 47.7747 15.2253 47.7747C13.9921 47.7747 13 48.7668 13 50C13 51.2332 13.9921 52.2253 15.2253 52.2253C16.4585 52.2253 17.4506 51.2332 17.4506 50Z"
        fill="white"
      />
      <path
        d="M86.9369 50C86.9369 48.7737 85.9448 47.7747 84.7116 47.7747C83.4784 47.7747 82.4863 48.7668 82.4863 50C82.4863 51.2332 83.4784 52.2253 84.7116 52.2253C85.9448 52.2253 86.9369 51.2332 86.9369 50Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_188_26533">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
